/* global __DEV__ */

/* eslint-disable camelcase */
import getConfig from 'next/config';
import Router, { withRouter } from 'next/router';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { withTheme, createGlobalStyle } from 'styled-components';
import is from 'is_js';
import AutoForm from 'react-auto-form';
import omit from 'lodash.omit';
import { notification } from 'antd';
import {
  Modal,
  Tooltip,
  // $FlowFixMe
} from '@bijie/react-bnb';

import withI18n from '../../utils/withI18n';
import { Link } from '../../routes';
import {
  fetchMarginOrderBorrowable,
  MARGIN_ORDER_ENUM,
  placeOrder as placeOrderAction,
  placeOrderSuccess as placeOrderSuccessAction,
} from '../../actions/actionsSet/order';
import {
  fetchMaxBorrowAmount,
  setMarginAccountMaxBorrowable as setMarginAccountMaxBorrowableAction,
  setMarginBorrow as setMarginBorrowAction,
  setMarginAutoRepay as setMarginAutoRepayAction,
} from '../../actions/actionsSet/margin';
import { fetchDepthData as fetchDepthDataAction } from '../../actions/load';
import {
  decimalPlaces,
  decRound,
  formatNumber,
  floor,
  equal,
  decMultiply,
  multiply,
  DASH, bigNumberPlus,
} from '../../utils/number';
import makeOrderTips from '../../utils/tips';
import { getLabel } from '../../utils/i18n';
import { getLoginUrl } from '../../utils/urlUtils';

import { FiatPrice } from '../FiatPrice';
import FormRow from './FormRow';
import PercentButton from './PercentButton';
import FlexBox from '../FlexBox';
import Icon from '../Icon';
import confirm from '../Confirmation';
import OrderConfirmation from './OrderConfirmation';

import feature from '../../config/feature';
import urlConfig from '../../config/urls';
import ModeButton from './ModeButton';
import ModeTip from './ModeTip';

const { user: { identity: IDENTITY_URL, withdrawals: WITHDRAWAL_URL } } = urlConfig;

const { enableRegister: ENABLE_REGISTER, orderFormTotalPrecision, fiatSymbol } = feature;

const TOTAL_DECIMALS = orderFormTotalPrecision;
const BLACK_LIST_MESSAGE = 'blacklistUser.not.enabled';

const {
  publicRuntimeConfig: { registerUrl: REGISTER_URL, assetPrefix },
} = getConfig();

const TooltipInject = createGlobalStyle`
  .bnc-tooltip-arrow{
    border-top-color: ${({ theme }) => `${theme.balanceTooltipBg} !important`};
  }
  .bnc-tooltip-inner {
     // background: red;
     background: ${({ theme }) => theme.balanceTooltipBg};
     color: ${({ theme }) => theme.fontColor};
  }
`;

const StyledOrderForm = styled.form.attrs(props => ({
  'autoComplete': props.off,
}))`
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
`;

const Button = styled.button`
  flex: 1;
  background: ${({ theme }) => theme.buttonbg || 'white'};
  border: 1px solid ${({ theme }) => theme.inputBorder || '#ccc'};
  border-color: ${({ selected }) => (selected ? '#999' : '')};
  cursor: pointer;
  padding: 3px;
  margin: ${({ margin }) => margin || '0 3px'};
  user-select: none;
  outline: none;
  ${({ side, theme }) => {
    const base = `
      color: white;
      font-size: 14px;

      /* only applies to buy/sell buttons */
      &:hover:not(:disabled) {
        filter: brightness(1.1);
      }`;
    if (side === 'BUY') {
      return `
        ${base}
        background: ${theme.up};
        border-color: ${theme.up};`;
    }
    if (side === 'SELL') {
      return `
        ${base}
        background: ${theme.down};
        border-color: ${theme.down};`;
    }
    // else
    return '';
  }}

  &:disabled {
    cursor: not-allowed;
  }
  &:nth-child(2) {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  `;

const PresetsFormRow = styled(FormRow)`
  max-height: 35px;
  `;

const LogInOrRegisterNotice = styled.div`
  background: ${({ theme }) => theme.boxheadbg};
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.inputBorder};
  flex: 1 1 auto;
  font-size: 12px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  & a {
    &,
    &:active,
    &:hover,
    &:visited {
      font-weight: bold;
      color: ${({ theme }) => theme.highlight};
    }
  }
  `;

const ErrorMsg = styled.div`
  height: 36px;
  line-height: 18px;
  font-size: 12px;
  color: #ef4b5a;
  `;

const InvisibleSubmitButton = styled.button`
    display:none;
  `;

const OcoHeader = styled(FlexBox)`
   margin-left: -16px;
   flex-wrap: nowrap;
   align-items: center;
`;

const Hr = styled.span`
   border-bottom: 1px dashed rgba(255,255,255,.2);
   margin-bottom: 5px;
`;

const ScaleDown = styled.div`
   display: inline-block;
   transform: scale(.5);
`;

const Label = styled.div`
  display: inline-block;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-weight: 600;
`;

const ModalContentText = styled.div`
  font-size: 14px;
`;

const IconWrapper = styled.div`
  cursor: pointer;
`;

const MODE_ENUMS = {
  NORMAL: 'NORMAL',
  BORROW: 'BORROW', // marginBorrow
  REPAY: 'REPAY', // marginAutoRepay
};

const defaultState = {
  'mode_BUY': MODE_ENUMS.NORMAL,
  'mode_SELL': MODE_ENUMS.NORMAL,
  'limit': {
    price: 0,
    price_display: '',
    quantity: 0,
    quantity_display: '',
    total: 0,
    total_display: '',
    errorMsg: '',
  },
  'market': {
    quantity: 0,
    quantity_display: '',
    errorMsg: '',
  },
  'stop-limit': {
    stopPrice: 0,
    stopPrice_display: '',
    stopLimitPrice: 0,
    stopLimitPrice_display: '',
    quantity: 0,
    quantity_display: '',
    total: 0,
    total_display: '',
    errorMsg: '',
  },
  'oco': {
    price: 0,
    price_display: '',
    stopPrice: 0,
    stopPrice_display: '',
    stopLimitPrice: 0,
    stopLimitPrice_display: '',
    quantity: 0,
    quantity_display: '',
    total: 0,
    total_display: '',
    errorMsg: '',
  },
  'moustAmount': DASH,
  'showModal': false,
  'modalMsg': '',
  'lastOrderFormAmount': {},
  'lastOrderFormPrice': {},
};

const mapStateToProps = ({
  isLoggedIn,
  userAssets,
  locale,
  fiatRate,
  currencyList,
  orderFormAmount,
  orderFormPrice,
  tickers,
  books,
  orders,
  userPreferredCurrency,
  userInfo,
  marginAccount: {
    marginFreeAssets, marginMaxBorrowable, userAssets: marginUserAssets,
  },
  marginStatus,
  isMarginPair,
  marginBorrow_BUY,
  marginBorrow_SELL,
  marginAutoRepay_BUY,
  marginAutoRepay_SELL,
}, { symbol }) => ({
  isLoggedIn,
  userAssets,
  locale,
  fiatRate,
  currencyList,
  orderFormAmount,
  orderFormPrice,
  orders,
  ticker: tickers[symbol],
  book: books[symbol],
  preferredCurrency: userPreferredCurrency,
  userInfo,
  marginFreeAssets,
  marginMaxBorrowable,
  marginUserAssets,
  marginStatus,
  isMarginPair,
  marginBorrow_BUY,
  marginBorrow_SELL,
  marginAutoRepay_BUY,
  marginAutoRepay_SELL,
});

export default
@withI18n
@withRouter
@withTheme
@connect(mapStateToProps, {
  placeOrder: placeOrderAction,
  placeOrderSuccess: placeOrderSuccessAction,
  setMarginAccountMaxBorrowable: setMarginAccountMaxBorrowableAction,
  setMarginBorrow: setMarginBorrowAction,
  setMarginAutoRepay: setMarginAutoRepayAction,
  fetchDepthData: fetchDepthDataAction,
})
class OrderForm extends Component {
  static propTypes = {
    i18n: PropTypes.object,
    router: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    userInfo: PropTypes.object,
    base: PropTypes.string.isRequired,
    pair: PropTypes.array.isRequired,
    side: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired,
    orderType: PropTypes.string.isRequired,
    tradeType: PropTypes.string,
    tickSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minTrade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    placeOrder: PropTypes.func.isRequired,
    placeOrderSuccess: PropTypes.func.isRequired,
    userAssets: PropTypes.object.isRequired,
    locale: PropTypes.string,
    currencyList: PropTypes.array,
    fiatRate: PropTypes.object.isRequired,
    orderFormAmount: PropTypes.object,
    orderFormPrice: PropTypes.object,
    ticker: PropTypes.object,
    book: PropTypes.object,
    orders: PropTypes.object,
    preferredCurrency: PropTypes.object,
    theme: PropTypes.object,
    marginFreeAssets: PropTypes.object,
    marginStatus: PropTypes.bool,
    isMarginPair: PropTypes.bool,
    pro: PropTypes.bool,
    marginBorrow_BUY: PropTypes.bool,
    marginBorrow_SELL: PropTypes.bool,
    marginAutoRepay_BUY: PropTypes.bool,
    marginAutoRepay_SELL: PropTypes.bool,
    marginUserAssets: PropTypes.array,
    marginMaxBorrowable: PropTypes.object,
    setMarginAccountMaxBorrowable: PropTypes.func,
    setMarginAutoRepay: PropTypes.func,
    fetchDepthData: PropTypes.func,
    setMarginBorrow: PropTypes.func,
  };

  static defaultProps = {
    i18n: {},
    locale: 'en',
    router: { asPath: '/' },
    userInfo: {},
    orderFormAmount: {},
    orderFormPrice: {},
    ticker: {},
    book: { bids: {}, asks: {} },
    orders: { isRequesting: false },
    currencyList: [],
    preferredCurrency: {},
    theme: {},
    marginStatus: false,
    isMarginPair: false,
    marginMaxBorrowable: {},
  };

  state = { ...defaultState };

  componentDidMount() {
    this._setPrice(this.props);
  }

  componentDidUpdate({ symbol }) {
    if (symbol !== this.props.symbol) {
      this._setPrice(this.props);
    }
  }

  static getDerivedStateFromProps(
    {
      isLoggedIn,
      userAssets,
      marginFreeAssets,
      symbol,
      pair,
      side,
      minTrade,
      tickSize,
      orderFormPrice,
      orderFormAmount,
      orderType,
      marginStatus,
      marginBorrow_BUY,
      marginBorrow_SELL,
      marginAutoRepay_BUY,
      marginAutoRepay_SELL,
      isMarginPair,
    },
    state
  ) {
    const freeAsset = isMarginPair && marginStatus ? marginFreeAssets : userAssets;
    if (
      orderFormPrice !== state.lastOrderFormPrice ||
      orderFormAmount !== state.lastOrderFormAmount
    ) {
      const mt = decimalPlaces(minTrade);
      const ts = decimalPlaces(tickSize);
      const newPrice = floor(orderFormPrice[symbol], ts);
      let newQuantity = orderFormAmount[symbol] || state[orderType].quantity;
      let newTotal = decMultiply(TOTAL_DECIMALS, newPrice, newQuantity);
      if (isLoggedIn) {
        if (side !== orderFormAmount.side) {
          if (side === 'SELL') {
            newQuantity = floor(
              Number(freeAsset[pair[0]]) >= Number(newQuantity) ? newQuantity : freeAsset[pair[0]],
              mt
            );
            newTotal = decMultiply(TOTAL_DECIMALS, newPrice, newQuantity);
          } else {
            const t = multiply(newPrice, newQuantity);
            if (t > freeAsset[pair[1]]) {
              newQuantity = floor(freeAsset[pair[1]] / newPrice, mt);
            }
            newTotal = decMultiply(TOTAL_DECIMALS, newQuantity, newPrice);
          }
        } else {
          newQuantity = 0;
          newTotal = 0;
        }
      } else if (side === orderFormAmount.side) {
        newQuantity = 0;
        newTotal = 0;
      }
      let modeBuy = MODE_ENUMS.NORMAL;
      let modeSell = MODE_ENUMS.NORMAL;
      if (marginBorrow_BUY) modeBuy = MODE_ENUMS.BORROW;
      if (marginAutoRepay_BUY) modeBuy = MODE_ENUMS.REPAY;
      if (marginBorrow_SELL) modeSell = MODE_ENUMS.BORROW;
      if (marginAutoRepay_SELL) modeSell = MODE_ENUMS.REPAY;

      return {
        'mode_BUY': modeBuy,
        'mode_SELL': modeSell,
        'limit': {
          price: newPrice,
          price_display: newPrice,
          quantity: newQuantity,
          quantity_display: equal(newQuantity, 0) ? '' : newQuantity,
          total: newTotal,
          total_display: equal(newTotal, 0) ? '' : newTotal,
        },
        'stop-limit': {
          stopPrice: newPrice,
          stopPrice_display: newPrice,
          stopLimitPrice: newPrice,
          stopLimitPrice_display: newPrice,
          quantity: newQuantity,
          quantity_display: equal(newQuantity, 0) ? '' : newQuantity,
          total: newTotal,
          total_display: equal(newTotal, 0) ? '' : newTotal,
        },
        'oco': {
          price: newPrice,
          price_display: newPrice,
          stopPrice: newPrice,
          stopPrice_display: newPrice,
          stopLimitPrice: newPrice,
          stopLimitPrice_display: newPrice,
          quantity: newQuantity,
          quantity_display: equal(newQuantity, 0) ? '' : newQuantity,
          total: newTotal,
          total_display: equal(newTotal, 0) ? '' : newTotal,
        },
        'lastOrderFormAmount': orderFormAmount,
        'lastOrderFormPrice': orderFormPrice,
      };
    }
    return null;
  }

  // avoids displaying scientific notation like `1e-8`
  // which happens by default in chrome
  // TODO: needs unit test
  _onChange = (ev, name, text) => {
    const { tickSize, minTrade, orderType } = this.props;
    if (text.endsWith('.')) {
      // safari...
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], {
          [`${name}_display`]: text,
        }),
      });
      return;
    }
    const min = name === 'quantity' ? minTrade : tickSize;

    const decimal = decimalPlaces(text);
    const precision = Math.min(Math.abs(Math.log10(+min)), decimal);
    let num = parseFloat(text);
    const isNaN = Number.isNaN(num);
    if (!isNaN && num < 0) num = Math.abs(num);
    const value = isNaN ? 0 : floor(num, precision, Math.floor);
    if (__DEV__) console.log(`[OrderForm] Setting '${name}' to '${value}'`);
    this.setState(
      {
        [orderType]: Object.assign({}, this.state[orderType], {
          [name]: value,
          [`${name}_display`]: isNaN ? '' : floor(num, precision, Math.floor),
        }),
      },
      () => {
        const {
          price: limitPrice, stopLimitPrice, quantity, total,
        } = this.state[orderType];
        let price = orderType === 'stop-limit' ? stopLimitPrice : limitPrice;
        if (orderType === 'oco') { price = +stopLimitPrice > +limitPrice ? stopLimitPrice : limitPrice; }
        const tk = decimalPlaces(tickSize);
        const mt = decimalPlaces(minTrade);
        if (name !== 'total' && price && quantity) {
          const t = multiply(price, quantity);
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              total: t,
              total_display: t === 0 ? '' : decRound(t, TOTAL_DECIMALS),
            }),
          });
        } else if (name !== 'total' && (!price || !quantity)) {
          const t = 0;
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              total: t,
              total_display: t === 0 ? '' : decRound(t, TOTAL_DECIMALS),
            }),
          });
        } else if (name !== 'quantity' && total && price) {
          const q = total / price;
          this.setState(
            {
              [orderType]: Object.assign({}, this.state[orderType], {
                quantity: floor(q, mt),
                quantity_display: q === 0 ? '' : floor(q, mt),
              }),
            },
            () => {
              this._hideErrorMsg('quantity');
            }
          );
        } else if (name !== 'price' && total && quantity) {
          const p = total / quantity;
          this.setState(
            {
              [orderType]: Object.assign({}, this.state[orderType], {
                price: floor(p, tk),
                price_display: p === 0 ? '' : floor(p, tk),
              }),
            },
            () => {
              this._hideErrorMsg('price');
            }
          );
        }
      }
    );
  };

  _checkValidity = () => {
    // TODO refactor
    const {
      orderType,
      side,
      userAssets,
      marginFreeAssets,
      pair,
      i18n,
      tickSize,
      minTrade,
      ticker,
      marginStatus,
      isMarginPair,
      marginBorrow_BUY,
      marginBorrow_SELL,
      marginMaxBorrowable,
    } = this.props;
    const {
      price: limitPrice, stopPrice, stopLimitPrice, quantity,
    } = this.state[orderType];
    const price = orderType === 'stop-limit' ? stopLimitPrice : limitPrice;
    const [base, quote] = pair;
    const assetName = side === 'BUY' ? quote : base;
    const borrowed = marginMaxBorrowable[assetName] || 0;
    const isMargin = isMarginPair && marginStatus;
    let total = isMargin ? marginFreeAssets[assetName] : userAssets[assetName];
    if (isMargin) {
      if ((side === 'BUY' && marginBorrow_BUY) || (side === 'SELL' && marginBorrow_SELL)) { total = bigNumberPlus(marginFreeAssets[assetName], borrowed); }
    }

    if (orderType === 'stop-limit' && +stopPrice < +tickSize) {
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], {
          errorMsg: getLabel('exchange-trade-inputCrrectPrice', i18n, 'Please input correct price'),
          stopError: true,
        }),
      });
      return false;
    }
    if (+price < +tickSize) {
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], {
          errorMsg: getLabel('exchange-trade-inputCrrectPrice', i18n, 'Please input correct price'),
          priceError: true,
        }),
      });
      return false;
    }
    if (+quantity < +minTrade) {
      const errorMsg =
        side === 'BUY'
          ? getLabel('exchange-trade-inputVolume', i18n, 'Please input buy amount')
          : getLabel('exchange-trade-inputSellVolume', i18n, 'Please input sell amount');
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], { errorMsg, quantityError: true }),
      });
      return false;
    }
    if (
      (side === 'BUY' &&
        !equal(multiply(price, quantity), +total) &&
        multiply(price, quantity) > +total) ||
      (side === 'SELL' && !equal(quantity, +total) && quantity > +total)
    ) {
      // not margin
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], {
          errorMsg: getLabel(
            'exchange-trade-insufficientBalance',
            i18n,
            'Your balance is not enough'
          ),
          quantityError: true,
        }),
      });
      return false;
    }
    if (orderType === 'market' && side === 'BUY') {
      if (
        (!marginStatus && multiply(ticker.c, quantity) > +total) ||
        (marginStatus && multiply(ticker.c, quantity) > +total)
      ) {
        this.setState({
          [orderType]: Object.assign({}, this.state[orderType], {
            errorMsg: getLabel(
              'exchange-trade-insufficientBalance',
              i18n,
              'Your balance is not enough'
            ),
            quantityError: true,
          }),
        });
        return false;
      }
    }
    if (orderType === 'oco') {
      if (side === 'BUY') {
        if (+stopPrice <= price) {
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              errorMsg: getLabel(
                'exchange-trade-ocoStopGtBuy',
                i18n,
                'Stop Price should greater than buy price'
              ),
              priceError: true,
            }),
          });
          return false;
        }
        if (+price >= +ticker.c) {
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              errorMsg: getLabel(
                'exchange-trade-ocoPriceLtMarket',
                i18n,
                'Price should less than market price'
              ),
              priceError: true,
            }),
          });
          return false;
        }
        if (+stopPrice <= +ticker.c) {
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              errorMsg: getLabel(
                'exchange-trade-ocoStopGtMarket',
                i18n,
                'Stop Price should greater than market price'
              ),
              priceError: true,
            }),
          });
          return false;
        }
      }
      if (side === 'SELL') {
        if (+stopPrice >= +price) {
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              errorMsg: getLabel(
                'exchange-trade-ocoStopLtSell',
                i18n,
                'Stop Price should less than sell price'
              ),
              priceError: true,
            }),
          });
          return false;
        }
        if (+price <= +ticker.c) {
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              errorMsg: getLabel(
                'exchange-trade-ocoPriceGtMarket',
                i18n,
                'Price should greater than market price'
              ),
              priceError: true,
            }),
          });
          return false;
        }
        if (+stopPrice >= +ticker.c) {
          this.setState({
            [orderType]: Object.assign({}, this.state[orderType], {
              errorMsg: getLabel(
                'exchange-trade-ocoStopLtMarket',
                i18n,
                'Stop Price should less than market price'
              ),
              priceError: true,
            }),
          });
          return false;
        }
      }
    }
    return true;
  };

  _checkMarketOrder = () => {
    const {
      orderType, ticker, side, book,
    } = this.props;
    const { quantity } = this.state[orderType];
    const depths = side === 'BUY' ? book.asks : book.bids;
    if (!is.undefined(depths)) {
      const depthsArray = Object.values(depths);
      let sum = 0;
      let price;
      for (let i = 0; i < depthsArray.length; i++) {
        sum += Number(depthsArray[i][1]);
        if (sum >= quantity || i === depthsArray.length - 1) {
          [price] = depthsArray[i];
          break;
        }
      }
      if (quantity > sum) {
        return Number.POSITIVE_INFINITY;
      }
      return Math.abs(+price - +ticker.c) / +ticker.c;
    }
    return 0;
  };

  _checkPriceGap = () => {
    const { orderType, ticker, side } = this.props;
    const { price } = this.state[orderType];
    const latestPrice = +ticker.c;
    let flag = false;
    if (orderType === 'limit' && latestPrice) {
      const diff = (price - latestPrice) / latestPrice;
      if ((side === 'BUY' && diff > 0.05) || (side === 'SELL' && -diff > 0.05)) {
        flag = true;
      }
    } else if (orderType === 'market' && latestPrice) {
      const diff = this._checkMarketOrder();
      if (Number(diff)) {
        flag = diff > 0.05;
      }
    }
    return flag;
  };

  _preparePlaceOrderInfo = async () => {
    const { fetchDepthData, symbol } = this.props;
    const payload = this._getPayload();
    const { sideEffectType } = payload;
    let borrowAmount = 0;
    if (sideEffectType && sideEffectType === MARGIN_ORDER_ENUM.MARGIN_BUY) {
      const { requiredBorrowAmount } = await fetchMarginOrderBorrowable(payload);
      if (requiredBorrowAmount) borrowAmount = Number(requiredBorrowAmount);
      fetchDepthData(symbol);
      this._showPlaceOrderInfo(payload, borrowAmount);
    } else {
      this._showPlaceOrderInfo(payload, borrowAmount);
    }
  };

  _showPlaceOrderInfo = (payload, borrowAmount) => {
    const { i18n } = this.props;
    const tip = this._getPlaceOrderTipTemplate(payload, borrowAmount);
    if (tip) {
      Modal.create({
        id: 'orderConfirmation',
        closable: false,
        title: false,
        width: 400,
        content: <ModalContentText>{tip}</ModalContentText>,
        onOk: () => this._onConfirm(),
        cancelText: `${getLabel('exchange-common-cancel', i18n, 'Cancel')}`,
        okText: `${getLabel('exchange-common-confirm', i18n, 'Place Order')}`,
      });
    } else {
      this._onConfirm();
    }
  };

  _onSubmit = async ev => {
    const { i18n } = this.props;
    ev.preventDefault();
    if (!this.props.isLoggedIn || !this._checkValidity()) return;
    // price gap tip
    if (this._checkPriceGap() && this._getPriceGapTip()) {
      Modal.create({
        content: <ModalContentText>{this._getPriceGapTip()}</ModalContentText>,
        onOk: () => this._preparePlaceOrderInfo(),
        cancelText: `${getLabel('exchange-common-cancel', i18n)}`,
        okText: `${getLabel('exchange-common-continue', i18n)}`,
      });
    } else {
      this._preparePlaceOrderInfo();
    }
  };

  _getCurrentOrderConfirmStatus = (orderType, orderConfirmStatus, borrowAmount) => {
    const { marginAutoBorrow, marginAutoRepay } = orderConfirmStatus;
    const {
      marginBorrow_BUY,
      marginBorrow_SELL,
      marginAutoRepay_BUY,
      marginAutoRepay_SELL,
      side,
    } = this.props;
    const marginBorrow =
      borrowAmount &&
      marginAutoBorrow &&
      ((marginBorrow_BUY && side === 'BUY') || (marginBorrow_SELL && side === 'SELL'));
    const marginRepay =
      marginAutoRepay &&
      ((marginAutoRepay_BUY && side === 'BUY') || (marginAutoRepay_SELL && side === 'SELL'));
    if (marginBorrow || marginRepay) return true;
    if (orderType === 'limit') {
      return orderConfirmStatus.limitOrder;
    }
    if (orderType === 'market') {
      return orderConfirmStatus.marketOrder;
    }
    if (orderType === 'oco') {
      return orderConfirmStatus.oco;
    }
    return orderConfirmStatus.stopLossOrder;
  };

  _getPlaceOrderTipTemplate = (payload, borrowAmount) => {
    const { userInfo, orderType } = this.props;
    if (!this._getCurrentOrderConfirmStatus(orderType, userInfo.orderConfirmStatus, borrowAmount)) { return false; }
    return <OrderConfirmation payload={payload} borrowAmount={borrowAmount} props={this.props} />;
  };

  _getOrderTips = quantity => makeOrderTips({ ...this.props, quantity });

  _onConfirm = async () => {
    const {
      marginBorrow_BUY,
      marginBorrow_SELL,
      locale,
      placeOrder,
      placeOrderSuccess,
      orderType,
      i18n,
      userInfo,
    } = this.props;
    const payload = this._getPayload();
    const { quantity } = payload;
    const { title, text } =
      !marginBorrow_BUY && !marginBorrow_SELL ? this._getOrderTips(quantity) : {};
    try {
      await placeOrder(
        payload,
        {
          successTitle: title,
          successText: text,
        },
        orderType,
      );
      this.setState(
        {
          [orderType]: Object.assign({}, this.state[orderType], {
            quantity: 0,
            quantity_display: '',
            total: 0,
            total_display: '',
          }),
        },
        () => {
          placeOrderSuccess();
          this._setMaxAmount();
        }
      );
    } catch (error) {
      if (error.message && error.message.trim() === BLACK_LIST_MESSAGE) {
        const okText =
          userInfo.idPhoto !== 1
            ? getLabel('exchange-trade-KYCVerification', i18n)
            : getLabel('exchange-trade-goToWithdraw', i18n);
        const widthdrawUrl = WITHDRAWAL_URL.endsWith('.html')
          ? WITHDRAWAL_URL
          : WITHDRAWAL_URL.replace('%locale', locale).replace('%coin', fiatSymbol);
        const jumpUrl = userInfo.idPhoto !== 1 ? IDENTITY_URL : widthdrawUrl;
        confirm({
          area: ['486px'],
          i18n,
          content: this._getBlackListInfo(),
          theme: this.props.theme,
          okText,
          cancelText: getLabel('Not now', this.props.i18n),
          onConfirm: () => {
            Router.push(jumpUrl);
          },
        });
      } else if (error) {
        notification.error({
          message: getLabel('exchange-trade-orderFailed', i18n, 'Order Error'),
          description:
            error.message === 'Order would trigger immediately.'
              ? getLabel('exchange-trade-orderFailed01', i18n)
              : error.message,
          duration: 10,
        });
      }
      this._setMaxAmount();
    }
  };

  _setMaxAmount = () => {
    const {
      marginStatus,
      marginBorrow_BUY,
      marginBorrow_SELL,
      setMarginAccountMaxBorrowable,
      pair: [base, quote],
    } = this.props;
    if (marginStatus) {
      if (marginBorrow_BUY) {
        fetchMaxBorrowAmount(quote).then(asset => setMarginAccountMaxBorrowable({ [quote]: asset })
        );
      }
      if (marginBorrow_SELL) {
        fetchMaxBorrowAmount(base).then(asset => setMarginAccountMaxBorrowable({ [base]: asset }));
      }
    }
  };

  _getTotal = () => {
    const { orderType, tickSize, ticker } = this.props;
    const { price, quantity, total } = this.state[orderType];
    if (orderType === 'stop-limit') return total;
    if (orderType === 'market') return decMultiply(decimalPlaces(tickSize), +ticker?.c, +quantity); // TODO market type total
    return decMultiply(decimalPlaces(tickSize), +price, +quantity);
  };

  _getConfirmText = () => {
    const {
      i18n, side, base, pair, orderType,
    } = this.props;
    const { quantity, stop, limit } = this.state;
    const [, quote] = pair;
    switch (orderType) {
      case 'limit':
        return `
          ${i18n[side]} ${quantity} ${base} \
          = \
          ${this._getTotal()} ${quote}?
        `;
      case 'market':
        return `
          ${i18n[side]} ${quantity} ${base} \
          ${i18n['market price'] || 'at market price'}?
        `;
      case 'stop-limit':
        return `
            ${i18n[side]} ${quantity} ${base} (
            ${getLabel('exchange-trade-StopPrice', i18n, 'stop')}: ${stop} ${quote}, \
            ${getLabel('exchange-trade-LimitPrice', i18n, 'limit')}: ${limit} ${quote}
          )
        ?
        `;
      default:
        throw new Error(`Unknown or unsupported order type ${orderType}`);
    }
  };

  _getLoginLinkHref = () => getLoginUrl(this.props.locale, this.props.router.asPath);

  _getUnit = name => {
    const { symbol, base } = this.props;
    const quate = symbol.replace(base, '');
    return name === 'quantity' ? base : quate;
  };

  _getAssetNameOfBalance = () => {
    const { side, symbol, base } = this.props;
    return side === 'BUY' ? symbol.replace(base, '') : base;
  };

  _getBalance = () => {
    const {
      isLoggedIn,
      isMarginPair,
      marginStatus,
      userAssets,
      marginFreeAssets,
      marginMaxBorrowable,
      marginBorrow_BUY,
      marginBorrow_SELL,
      pair,
      side,
    } = this.props;
    const assetName = this._getAssetNameOfBalance();
    const balance = {
      val: 0,
      valDisplay: DASH,
    };
    if (isLoggedIn) {
      const ts = 8;
      if (isMarginPair && marginStatus && marginFreeAssets[assetName] !== undefined) {
        const [base, quote] = pair;
        if (marginBorrow_BUY && side === 'BUY') {
          const borrowed = marginMaxBorrowable[quote] || 0;
          const total = bigNumberPlus(marginFreeAssets[assetName], borrowed);
          balance.val = total;
          balance.valDisplay = formatNumber(total, ts);
        } else if (marginBorrow_SELL && side === 'SELL') {
          const borrowed = marginMaxBorrowable[base] || 0;
          const total = bigNumberPlus(marginFreeAssets[assetName], borrowed);
          balance.val = total;
          balance.valDisplay = formatNumber(total, ts);
        } else {
          balance.val = marginFreeAssets[assetName];
          balance.valDisplay = formatNumber(balance.val, ts);
        }
      } else if (userAssets[assetName] !== undefined) {
        balance.val = userAssets[assetName];
        balance.valDisplay = formatNumber(balance.val, ts);
      }
    }
    return balance;
  };

  _orderPercent = percent => {
    const { side, minTrade, orderType } = this.props;
    const balance = this._getBalance();
    const precision = decimalPlaces(minTrade);
    let quantity;
    let total;
    if (balance.valDisplay !== DASH) {
      const price = this._getPrice();
      if (side === 'BUY' && price) {
        total = multiply(balance.val, Number(percent));
        quantity = total / price;
      } else if (side === 'SELL') {
        quantity = multiply(balance.val, Number(percent));
      }
      if (!is.undefined(quantity)) {
        this.setState(
          {
            [orderType]: Object.assign({}, this.state[orderType], {
              quantity: floor(quantity, precision),
              quantity_display: floor(quantity, precision),
            }),
          },
          () => {
            const qt = this.state[orderType].quantity;
            const t = decMultiply(TOTAL_DECIMALS, qt, price);
            this.setState(
              {
                [orderType]: Object.assign({}, this.state[orderType], {
                  total: t,
                  total_display: t,
                }),
              },
              () => {
                this._hideErrorMsg('quantity');
              }
            );
          }
        );
      }
    }
  };

  _getPriceGapTip = () => {
    const {
      orderType, side, i18n, ticker, locale,
    } = this.props;
    if (!ticker.c) return '';
    if (orderType === 'limit' && side === 'BUY') {
      // Your order price is 5% higher than the latest market price.
      return getLabel('exchange-orderForm-buyorderConfirmTip', i18n);
    }
    if (orderType === 'limit' && side === 'SELL') {
      return getLabel('exchange-orderForm-SELLorderConfirmTip', i18n);
    }
    if (orderType === 'market') {
      const percent = Number(decRound(multiply(this._checkMarketOrder(), 100), 0));
      if (!Number.isFinite(percent)) {
        return getLabel('exchange-trade-largePriceDeviation', i18n);
      }
      return locale === 'cn'
        ? `您的订单成交价将${side === 'BUY' ? '高于' : '低于'}最新价${percent}%，请谨慎操作。 `
        : `Your order price will be ${percent}% ${
          side === 'BUY' ? 'higher' : 'less'
        } than the latest market price.
        Please proceed cautiously.`;
    }
    return false;
  };

  _getMostAmount = () => {
    const {
      minTrade, side, isLoggedIn, marginStatus, orderType,
    } = this.props;
    if (!isLoggedIn) return DASH;
    const qtyTick = Math.abs(Math.log10(minTrade));
    const price = this._getPrice();
    const balance = this._getBalance();
    let mostAmount;
    if (side === 'BUY') {
      mostAmount =
        price && balance.val && Number(price) !== 0
          ? floor(Number(balance.val) / Number(price), qtyTick)
          : DASH;
    } else {
      mostAmount = floor(balance.val, qtyTick);
    }

    const mt = decimalPlaces(minTrade);
    if (marginStatus && side === 'BUY' && orderType === 'market') { return floor(mostAmount * 0.99, mt); }
    return mostAmount;
  };

  _getFiatPrice = price => {
    const {
      locale, fiatRate, base, symbol, currencyList, preferredCurrency,
    } = this.props;
    const quate = symbol.replace(base, '');
    return (
      <FiatPrice
        fiatRate={fiatRate}
        currencyList={currencyList}
        locale={locale}
        price={price}
        quoteAsset={quate}
        preferredCurrency={preferredCurrency}
      />
    );
  };

  _setPrice = props => {
    const { ticker, tickSize, orderType } = props;
    const lp = +ticker.c;
    if (lp && tickSize) {
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], {
          price: lp,
          price_display: floor(lp, decimalPlaces(tickSize)),
          quantity: 0,
          quantity_display: '',
          total: 0,
          total_display: '',
        }),
      });
    }
  };

  _hideErrorMsg = target => {
    const { orderType } = this.props;
    const { errorMsg } = this.state[orderType];
    if (errorMsg) {
      this.setState({
        [orderType]: Object.assign({}, this.state[orderType], {
          errorMsg: '',
          [`${target}Error`]: false,
        }),
      });
    }
  };

  _getBlackListInfo = () => {
    const { userInfo, i18n } = this.props;
    const msg =
      userInfo.idPhoto !== 1
        ? getLabel('exchange-trade-goToIdentityTip', i18n)
        : getLabel('exchange-trade-forbidentLoginTip', i18n);
    return (
      <FlexBox>
        <FlexBox margin="20px 0 0 0" justify="center" flex="1">
          <img src={`${assetPrefix}/static/images/pics/forbidentLog.jpg`} alt="forbid" />
        </FlexBox>
        <FlexBox margin="40px">{msg}</FlexBox>
      </FlexBox>
    );
  };

  _handleModeSwitch = mode => {
    const { side, setMarginAutoRepay, setMarginBorrow } = this.props;
    switch (mode) {
      case MODE_ENUMS.NORMAL:
        this.setState({ [`mode_${side}`]: MODE_ENUMS.NORMAL }, () => {
          setMarginAutoRepay(false, side);
          setMarginBorrow(false, side);
        });
        break;
      case MODE_ENUMS.BORROW:
        this.setState({ [`mode_${side}`]: MODE_ENUMS.BORROW }, () => {
          setMarginAutoRepay(false, side);
          setMarginBorrow(true, side);
          this._setMaxBorrowable();
        });
        break;

      case MODE_ENUMS.REPAY:
        this.setState({ [`mode_${side}`]: MODE_ENUMS.REPAY }, () => {
          setMarginAutoRepay(true, side);
          setMarginBorrow(false, side);
        });
        break;
      default:
        break;
    }
  };

  _setMaxBorrowable = () => {
    const { pair, side, setMarginAccountMaxBorrowable } = this.props;
    const [base, quote] = pair;
    if (side === 'BUY') {
      fetchMaxBorrowAmount(quote).then(asset => setMarginAccountMaxBorrowable({ [quote]: asset }));
    }
    if (side === 'SELL') {
      fetchMaxBorrowAmount(base).then(asset => setMarginAccountMaxBorrowable({ [base]: asset }));
    }
  };

  _renderButton = () => {
    const {
      i18n,
      base,
      side,
      isLoggedIn,
      orders: { isRequesting },
      locale,
      tradeType,
      orderType,
      marginBorrow_BUY,
      marginBorrow_SELL,
      isMarginPair,
      marginStatus,
    } = this.props;
    if (is.undefined(isLoggedIn)) {
      return null;
    }
    const buyLabel = getLabel('exchange-TradeOrdersTable-Buy', i18n, side);
    const sellLabel = getLabel('exchange-TradeOrdersTable-Sell', i18n, side);
    const marginLabel = getLabel('exchange-trade-margin', i18n, 'Margin');
    const isMargin = marginStatus && isMarginPair;
    // eslint-disable-next-line no-nested-ternary
    let label = side === 'BUY'
      ? isMargin && marginBorrow_BUY
        ? `${marginLabel} ${buyLabel}`
        : buyLabel
      : isMargin && marginBorrow_SELL
        ? `${marginLabel} ${sellLabel}`
        : sellLabel;
    if (orderType === 'oco') label = side === 'BUY' ? buyLabel : sellLabel;
    return (
      <FormRow noLabel={true} last={true} side={side} height={34} margin="0">
        {isLoggedIn ? (
          <Button
            disabled={isRequesting}
            type="button"
            margin="0"
            side={side}
            onClick={this._onSubmit}
            id={
              side === 'BUY'
                ? `orderForm-button-${tradeType}${orderType}Buy`
                : `orderForm-button-${tradeType}${orderType}Sell`
            }
          >
            {locale === 'tr' ? (
              <Fragment>
                {base} {label}
              </Fragment>
            ) : (
              <Fragment>
                {label} {base}
              </Fragment>
            )}
          </Button>
        ) : (
          <LogInOrRegisterNotice>
            <Link href={this._getLoginLinkHref()}>
              <a id={`trade-orderForm-a-${side}login`}>
                {getLabel('exchange-login-signIn', i18n, 'Log in')}
              </a>
            </Link>{' '}
            {ENABLE_REGISTER && (
              <span>
                {getLabel('exchange-trade-or', i18n, 'or')}{' '}
                <Link href={REGISTER_URL.replace('%locale', locale)}>
                  <a id={`trade-orderForm-a-${side}register`}>
                    {getLabel('exchange-trade-userRegister', i18n, 'register')}
                  </a>
                </Link>{' '}
              </span>
            )}
            {getLabel('exchange-trade-toTrade', i18n, 'to trade')}
          </LogInOrRegisterNotice>
        )}
      </FormRow>
    );
  };

  _getPayload() {
    const {
      symbol,
      side,
      orderType,
      ticker,
      orders: { isRequesting },
      marginStatus,
    } = this.props;
    const {
      price, quantity, stopPrice, stopLimitPrice,
    } = this.state[orderType];
    const marginBorrow = this.state[`mode_${side}`] === MODE_ENUMS.BORROW;
    const marginAutoRepay = this.state[`mode_${side}`] === MODE_ENUMS.REPAY;
    try {
      if (price === 0 || quantity === 0 || isRequesting) return {};
      const latestPrice = +ticker.c;
      // exchange
      let params = {
        quantity,
        side,
        type: orderType.toUpperCase(),
        symbol,
      };

      if (orderType === 'stop-limit') {
        let type;
        if (side === 'BUY') {
          type = stopPrice >= latestPrice ? 'STOP_LOSS_LIMIT' : 'TAKE_PROFIT_LIMIT';
        } else {
          type = stopPrice > latestPrice ? 'TAKE_PROFIT_LIMIT' : 'STOP_LOSS_LIMIT';
        }
        params = Object.assign({}, params, { price: stopLimitPrice, stopPrice, type });
      } else if (orderType === 'limit') {
        params = Object.assign({}, params, { price });
      } else if (orderType === 'oco') {
        params = Object.assign({}, params, { price, stopPrice, stopLimitPrice, stopLimitTimeInForce: 'GTC' });
        params = omit(params, 'type');
      }

      let payload = { ...params };
      if (marginStatus) {
        // margin
        let sideEffectType = MARGIN_ORDER_ENUM.NO_SIDE_EFFECT; // default
        if (marginBorrow) sideEffectType = MARGIN_ORDER_ENUM.MARGIN_BUY; // borrow
        if (marginAutoRepay) sideEffectType = MARGIN_ORDER_ENUM.AUTO_REPAY; // repay
        payload = {
          ...params,
          sideEffectType,
        };
        orderType === 'oco' && (payload.isOco = true);
      }
      return payload;
    } catch (e) {
      return {};
    }
  }

  _getPrice() {
    const { orderType, ticker } = this.props;
    const { price: limitPrice, stopLimitPrice } = this.state[orderType];
    let price = orderType === 'stop-limit' ? stopLimitPrice : limitPrice;
    if (orderType === 'oco') price = +stopLimitPrice > +limitPrice ? stopLimitPrice : limitPrice;
    const latestPrice = +ticker.c;
    return orderType === 'market' ? latestPrice : price;
  }

  render() {
    const {
      i18n,
      base,
      side,
      orderType,
      tickSize,
      minTrade,
      locale,
      pair,
      pro,
      marginStatus,
      isMarginPair,
    } = this.props;
    const {
      errorMsg, priceError, quantityError, stopError,
    } = this.state[orderType];
    const mode = this.state[`mode_${side}`];
    const isMargin = marginStatus && isMarginPair;

    return (
      <AutoForm
        component={StyledOrderForm}
        onChange={this._onChange}
        onSubmit={this._onSubmit}
        trim={true}
        noValidate={true}
        autoComplete="off"
      >
        <FormRow
          heading={
            locale === 'tr'
              ? `${base || ''}  ${getLabel(`${'exchange-trade'}-${side}`, i18n, side)}  `
              : `${getLabel(`${'exchange-trade'}-${side}`, i18n, side)} ${base || ''} `
          }
          assetName={this._getAssetNameOfBalance()}
          balance={this._getBalance().valDisplay}
          height={18}
          first={true}
          pair={pair}
          side={side}
          orderType={orderType}
        />

        {isMargin && (
          <FlexBox margin="0 0 5px 0" wrap="nowrap">
            <FlexBox basis="25%" align="center">
              {getLabel('exchange-common-mode', i18n, 'Mode')}:
              <TooltipInject />
              <Tooltip placement="top" trigger={['click']} overlay={<ModeTip i18n={i18n} />}>
                <IconWrapper>
                  &nbsp;
                  <Icon type="prompt" size={12} />
                </IconWrapper>
              </Tooltip>
            </FlexBox>
            <FlexBox basis="75%" wrap="nowrap">
              <ModeButton
                text={getLabel('exchange-common-mode-normal', i18n, 'Normal')}
                value={MODE_ENUMS.NORMAL}
                selected={mode === MODE_ENUMS.NORMAL}
                onClick={this._handleModeSwitch}
              />
              <ModeButton
                text={getLabel('exchange-common-mode-borrow', i18n, 'Borrow')}
                value={MODE_ENUMS.BORROW}
                selected={mode === MODE_ENUMS.BORROW}
                onClick={this._handleModeSwitch}
              />
              <ModeButton
                text={getLabel('exchange-common-mode-repay', i18n, 'Repay')}
                value={MODE_ENUMS.REPAY}
                selected={mode === MODE_ENUMS.REPAY}
                onClick={this._handleModeSwitch}
              />
            </FlexBox>
          </FlexBox>
        )}

        {orderType === 'limit' || orderType === 'market' ? (
          <FormRow
            name="price"
            side={side}
            label={getLabel('exchange-trade-Price', i18n, 'Price')}
            disabled={orderType === 'market'}
            placeholder={
              orderType === 'market'
                ? getLabel('exchange-trade-MarketPrice', i18n, 'Market Price')
                : ''
            }
            tickSize={tickSize}
            minTrade={tickSize}
            value={this.state.limit.price_display}
            fiatPrice={this._getFiatPrice(this.state.limit.price_display)}
            unit={this._getUnit()}
            invalid={priceError}
            onFocus={() => {
              this._hideErrorMsg('price');
            }}
          />
        ) : null}
        {orderType === 'oco' ? (
          <Fragment>
            {pro ? null : (
              <OcoHeader>
                <ScaleDown>
                  <Icon type="banner-right1" />
                </ScaleDown>
                <Label>{getLabel('exchange-cancelEnums-limitOrder', i18n)}</Label>
              </OcoHeader>
            )}
            <FormRow
              name="price"
              side={side}
              label={getLabel('exchange-trade-Price', i18n, 'Price')}
              tickSize={tickSize}
              minTrade={tickSize}
              value={this.state.oco.price_display}
              fiatPrice={this._getFiatPrice(this.state.oco.price_display)}
              unit={this._getUnit()}
              invalid={priceError}
              onFocus={() => {
                this._hideErrorMsg('price');
              }}
            />
            {pro ? <Hr /> : null}
          </Fragment>
        ) : null}
        {orderType === 'stop-limit' ? (
          <Fragment>
            <FormRow
              name="stopPrice"
              side={side}
              label={getLabel('exchange-trade-StopPrice', i18n, 'Stop')}
              tickSize={tickSize}
              minTrade={tickSize}
              value={this.state['stop-limit'].stopPrice_display}
              fiatPrice={this._getFiatPrice(this.state['stop-limit'].stopPrice_display)}
              unit={this._getUnit()}
              invalid={stopError}
              onFocus={() => {
                this._hideErrorMsg('stop');
              }}
            />
            <FormRow
              name="stopLimitPrice"
              side={side}
              label={getLabel('exchange-trade-LimitPrice', i18n, 'Limit')}
              tickSize={tickSize}
              minTrade={tickSize}
              value={this.state['stop-limit'].stopLimitPrice_display}
              fiatPrice={this._getFiatPrice(this.state['stop-limit'].stopLimitPrice_display)}
              unit={this._getUnit()}
              invalid={priceError}
              onFocus={() => {
                this._hideErrorMsg('price');
              }}
            />
          </Fragment>
        ) : null}
        {orderType === 'oco' ? (
          <Fragment>
            {pro ? null : (
              <OcoHeader>
                <ScaleDown>
                  <Icon type="banner-right1" />
                </ScaleDown>
                <Label>{getLabel('exchange-cancelEnums-stopLimitOrder', i18n)}</Label>
              </OcoHeader>
            )}
            <FormRow
              name="stopPrice"
              side={side}
              label={getLabel('exchange-trade-StopPrice', i18n, 'Stop')}
              tickSize={tickSize}
              minTrade={tickSize}
              value={this.state.oco.stopPrice_display}
              fiatPrice={this._getFiatPrice(this.state['stop-limit'].stopPrice_display)}
              unit={this._getUnit()}
              invalid={priceError}
              onFocus={() => {
                this._hideErrorMsg('price');
              }}
            />
            <FormRow
              name="stopLimitPrice"
              side={side}
              label={getLabel('exchange-trade-LimitPrice', i18n, 'Limit')}
              tickSize={tickSize}
              minTrade={tickSize}
              value={this.state.oco.stopLimitPrice_display}
              fiatPrice={this._getFiatPrice(this.state['stop-limit'].stopLimitPrice_display)}
              unit={this._getUnit()}
              // invalid={priceError}
              // onFocus={() => { this._hideErrorMsg('price'); }}
            />
            {pro ? <Hr /> : null}
          </Fragment>
        ) : null}
        <FormRow
          name="quantity"
          side={side}
          label={getLabel('exchange-common-amount', i18n, 'Amount')}
          tickSize={minTrade}
          minTrade={minTrade}
          value={this.state[orderType].quantity_display}
          mostAmount={this._getMostAmount()}
          unit={this._getUnit('quantity')}
          invalid={quantityError}
          onFocus={() => {
            this._hideErrorMsg('quantity');
          }}
        />
        <PresetsFormRow label="" side={side} height={20}>
          <PercentButton
            percentBtn={`${side === 'BUY' ? 'OrderForm-input-Buy-25' : 'OrderForm-input-Sell-25'}`}
            value="0.25"
            onClick={this._orderPercent}
          />
          <PercentButton
            percentBtn={`${side === 'BUY' ? 'OrderForm-input-Buy-50' : 'OrderForm-input-Sell-50'}`}
            value="0.50"
            onClick={this._orderPercent}
          />
          <PercentButton
            percentBtn={`${side === 'BUY' ? 'OrderForm-input-Buy-75' : 'OrderForm-input-Sell-75'}`}
            value="0.75"
            onClick={this._orderPercent}
          />
          <PercentButton
            percentBtn={`${
              side === 'BUY' ? 'OrderForm-input-Buy-100' : 'OrderForm-input-Sell-100'
            }`}
            value="1.00"
            onClick={this._orderPercent}
          />
        </PresetsFormRow>
        {orderType !== 'market' ? (
          <FormRow
            name="total"
            side={side}
            label={getLabel('exchange-trade-Total', i18n, 'Total')}
            value={this.state[orderType].total_display}
            unit={this._getUnit()}
          />
        ) : null}
        <PresetsFormRow label="" side={side} height={16} margin="-3px 0 3px 0">
          <ErrorMsg>{errorMsg}</ErrorMsg>
        </PresetsFormRow>
        {this._renderButton()}
        {orderType === 'market' ? <FormRow /> : null}

        {/* this hidden button allows user to press "enter" key to show confirm popup */}
        <InvisibleSubmitButton type="submit" />
      </AutoForm>
    );
  }
}
